// ©2024 Austin App House. All rights reserved.
import React, { useState } from 'react';
import { MDBRow, MDBCol } from 'mdbreact';
import ContractorRating from '../ContractorRating';
import ContractorCertificatesChecks from '../ContractorCertificatesChecks';
import ContractorPreferedGroupsChecks from '../PreferedGroupsCheck';
import TravelExpenses from './CounterOfferElements/TravelExpenses';
import DateAndTime from './CounterOfferElements/DateAndTime';
import ExplanationInputModal from '../../modal/ExplenationInputModal';
import workOrderStatusControl from '../../../utils/workOrderStatusControl';
import { localCurrencySettings } from '../../../utils/constans';

const InvitedContractorCard = ({
                                   userType,
                                   contractorInfo,
                                   toggleModal,
                                   setCurrentApplicants,
                                   currentWorkOrder,
                                   unRouteWorkOrder,
                                   acceptInvite,
                               }) => {
    const [showModal, setShowModal] = useState(false);

    const contractor = contractorInfo.contractor_details || {};
    const workOrderControl = workOrderStatusControl(currentWorkOrder?.status);

    const acceptOnBehalf = (message) => {
        acceptInvite({
            workOrdersId: [currentWorkOrder._id],
            contractorId: contractorInfo.contractor_id,
            historyMessage: message,
        });
    };

    return (
        <tr className="line_blocks">
            <td className="deployment_section">
                <div className="page_row">
                    {/* === LEFT SIDE: Contractor Info === */}
                    <div className="right_col">
                        <div
                            className="block_label clickable"
                            onClick={() => {
                                setCurrentApplicants(contractorInfo);
                                toggleModal(true, 'contractorDetailsModal', true, {
                                    contractorId: contractor.userId,
                                });
                            }}
                        >
                            {`${contractorInfo.contractor_name} - ${contractor.unique_id}`}
                        </div>

                        <div className="info_block">
                            <div>{contractor.address}</div>
                            <div>
                                {contractor.city?.label ? `${contractor.city.label}, ` : ''}
                                {contractor.state?.label ? `${contractor.state.label} ` : ''}
                                {contractor.zipcode || ''}
                            </div>
                        </div>

                        {contractorInfo.comment && (
                            <div className="info_block">Comment — {contractorInfo.comment}</div>
                        )}
                    </div>

                    {/* === RIGHT SIDE: Pay Info === */}
                    <div className="left_col">
                        <div className="block_label">
                            {`Base Pay: ${(+currentWorkOrder.amount).toLocaleString(
                                'en-US',
                                localCurrencySettings
                            )}`}
                            <br />
                            {`Variable Pay: ${(+currentWorkOrder.variableAmount || 0).toLocaleString(
                                'en-US',
                                localCurrencySettings
                            )}`}
                        </div>

                        <DateAndTime
                            startDate={contractorInfo.startDate}
                            startTime={contractorInfo.startTime}
                        />
                    </div>
                </div>

                {/* === CONTACT INFO === */}
                <ul className="info_list">
                    {contractorInfo.amountExpense || contractorInfo.descriptionExpense || contractorInfo.comment ? (
                        <li
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '6px',
                                marginBottom: '12px',
                            }}
                        >
                            <span style={{ fontWeight: '700', fontSize: '15px' }}>Travel Expenses:</span>

                            {contractorInfo.amountExpense && (
                                <span style={{color: '#0484bb', fontWeight: '600'}}>
          <strong>Amount:</strong>{' '}
                                    {(+contractorInfo.amountExpense).toLocaleString('en-US', localCurrencySettings)}
        </span>
                            )}

                            {contractorInfo.descriptionExpense && (
                                <>
                                    <span style={{ fontWeight: '600' }}>Travel Expense Description:</span>
                                    <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {contractorInfo.descriptionExpense}
          </span>
                                </>
                            )}
                        </li>
                    ) : null}

                    {contractorInfo.comment && (
                        <li
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '4px',
                                marginBottom: '8px',
                            }}
                        >
                            <span style={{ fontWeight: '600' }}>Comment</span>
                            <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
      {contractorInfo.comment}
    </span>
                        </li>
                    )}
                    <li>
                        <span>Phone</span>
                        <span>
              <a href={`tel:${contractor.phone}`}>{contractor.phone}</a>
            </span>
                    </li>
                    <li>
                        <span>Email</span>
                        <span>
              <a href={`mailto:${contractor.email}`}>{contractor.email}</a>
            </span>
                    </li>
                    {contractor.distance ? (
                        <li>
                            <span>Distance</span>
                            <span>{contractor.distance.toFixed(2)} Miles</span>
                        </li>
                    ) : null}
                </ul>

                {/* === CERTIFICATES & GROUPS === */}
                <MDBRow>
                    <MDBCol>
                        {contractorInfo.groups?.length ? (
                            <ContractorPreferedGroupsChecks />
                        ) : null}
                    </MDBCol>
                    <MDBCol>
                        <ContractorCertificatesChecks
                            certificates={contractor.certificates}
                            textAlign="center"
                        />
                    </MDBCol>
                </MDBRow>

                {/* === TRAVEL EXPENSES === */}
                <TravelExpenses
                    amount={contractorInfo.amountExpense}
                    description={contractorInfo.descriptionExpense}
                />

                {/* === RATING === */}
                <ContractorRating contractor={contractor} />

                {/* === ACTION BUTTONS === */}
                <div className="profile_actions">
                    {workOrderControl.beforeAssigned && userType === 'client' && (
                        <>
                            {Object.values(contractorInfo.block).some((el) => el) ? (
                                <button
                                    type="button"
                                    className="standard_btn danger_btn"
                                    onClick={() =>
                                        toggleModal(true, 'blockModal', false, {
                                            contractorId: contractorInfo.contractor_id,
                                        })
                                    }
                                >
                                    Blocked
                                </button>
                            ) : (
                                <button type="button" className="standard_btn danger_btn">
                                    Routed
                                </button>
                            )}

                            <button
                                type="button"
                                className="standard_btn light_btn"
                                onClick={() =>
                                    unRouteWorkOrder(currentWorkOrder._id, contractorInfo.contractor_id)
                                }
                            >
                                Un-Route
                            </button>

                            <button
                                type="button"
                                className="standard_btn light_btn"
                                onClick={() => setShowModal(true)}
                            >
                                Accept On Behalf
                            </button>

                            <ExplanationInputModal
                                title="Reason to accept on behalf"
                                warningMessage="Please enter valid reason"
                                isCloseAvailable
                                useOutOfState
                                isOpen={showModal}
                                changeIsOpen={setShowModal}
                                returnExplanation={acceptOnBehalf}
                            />
                        </>
                    )}
                </div>
            </td>
        </tr>
    );
};

export default InvitedContractorCard;
